import "./PromoAppliance.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { Rating } from "@sbi-international/boutik.gatsby.plugin.components";
import { popFrontURL } from "../../utils";

import GatsbyImageWrapper from "../GatsbyImageWrapper";
import { DroletButton } from "../primitives";
import { AllHeaterProductSingleModel } from "../../models/allHeaterProductSingleModel";
import { ICurrentPrice } from "@sbi-international/boutik.gatsby.plugin.services";

export default function PromoApplianceSingle(props: {
    appliance: AllHeaterProductSingleModel;
    id?: string;
}) {
    const { appliance, id } = props;
    const { currentLocale, navigateTranslated } = usePageLocalization();

    const { t } = useTranslation("pages");

    const fromDate = appliance?.live?.special.fromDate?.split(" ")?.[0];
    const toDate = appliance?.live?.special.toDate?.split(" ")?.[0];
    const dates = getDateStr(fromDate, toDate, t);
   

    const productReviews = appliance.productReviews;

    const goToSinglePage = () => {
        navigateTranslated(popFrontURL(appliance?.static.slug?.[currentLocale], 2));
    };
    return (
        <div className="appliance-single-promo" id={id || undefined}>
            {true && (
                <div className="discount-tag">
                    {getPricePercentage(appliance?.live?.currentPrice)}
                </div>
            )}
            <div className="single-image" onClick={() => goToSinglePage()}>
                <GatsbyImageWrapper fields={appliance.static.fields} />
            </div>

            <div className="single-content">
                <span className="single-size">
                    {appliance?.static?.attributes?.size?.values?.[0]?.[currentLocale]}
                </span>
                <span className="single-title">{appliance?.static?.title?.[currentLocale]}</span>
                <span className="line"></span>
                <span className="single-sku">{appliance?.static.code}</span>
                <span className="single-price">
                    {getProductPrice(appliance?.live?.currentPrice)}
                </span>
                {productReviews && (productReviews?.count ?? 0) > 0 && (
                    <div className="single-ratings">
                        <div className="rating">
                            <Rating.RatingScore
                                ratingScore={productReviews?.average ?? 0}
                                ratingCount={productReviews?.count ?? 0}
                            />
                        </div>
                    </div>
                )}
                {dates && <div className="date-range">{dates}</div>}
                <DroletButton
                    label={t("home.see-product") ?? ""}
                    onClick={() => goToSinglePage()}
                />
            </div>
        </div>
    );

    function getProductPrice(price: ICurrentPrice | undefined) {
        if (!price) return null;
        if (price?.regularPrice.value === price?.finalPrice.value) {
            return <span className="normal-price">{price?.regularPrice.formattedValue}</span>;
        } else if (
            price?.regularPrice.value &&
            price?.finalPrice.value &&
            price.regularPrice.value !== price.finalPrice.value
        ) {
            return (
                <div className="discount-price">
                    <span className="regular-price">{price?.regularPrice.formattedValue}</span>
                    <span className="final-price">{price?.finalPrice.formattedValue}</span>
                </div>
            );
        }
        return null;
    }
}

function getPricePercentage(price: ICurrentPrice | undefined): string {
    if (!price) return "--";
    if (price?.discount?.percentOff) return `-${price?.discount?.percentOff?.toFixed(0)}%`;
    else {
        if (
            price?.regularPrice?.value == null ||
            price?.finalPrice?.value == null ||
            price?.regularPrice?.value === 0 ||
            price?.finalPrice?.value === 0
        ) {
            return `--`;
        }
        const result =
            (100 * (price.regularPrice.value - price.finalPrice.value)) / price.regularPrice.value;
        return `-${result.toFixed(0)}%`;
    }
}

function getDateStr(
    fromDate: string | undefined,
    toDate: string | undefined,
    t: any
): string | undefined {
    if ((!fromDate && !toDate) || (fromDate && !toDate)) return undefined;
    else if (!fromDate && toDate) return `${t("layout:appliance.valid-until")} ${toDate}`;
    else return `${t("promotions.date-label", { from: fromDate, to: toDate })}`;
}
